import * as React from "react";
import styles from "./styles.scss";

const Heading = (props: React.PropsWithChildren<unknown>) => {
  return <h2 className={styles.heading}>{props.children}</h2>;
};

export default Heading;
